export default __webpack_public_path__ + "static/media/default.d3714e00.svg";